import script from "./BaseAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseAlert.vue?vue&type=script&setup=true&lang=ts"

import "./BaseAlert.vue?vue&type=style&index=0&id=1759ec0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1759ec0f"]])

export default __exports__